lmApp.service('LiveEventResource', ['$resource', function ($resource) {
  return $resource('/discovery:80/sdp/v2/live-events',
    null,
    {
      get: {
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        },
        isArray: true,
        transformResponse: function (data) {
          var result = angular.fromJson(data);
          return (result.data || [])
        }
      },
      count: {
        url: '/discovery:80/sdp/v2/live-events/$count',
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      getHLSStream: {
        url: '/discovery:80/sdp/v2/live-events/:id/catchup-url',
        method: 'GET',
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken'),
          'X-Instance-Check': ''
        },
        params: {
          id: '@id'
        }
      },
      getDashStream: {
        url: '/discovery:80/sdp/v2/live-events/:id/catchup-url?stream_format=dash',
        method: 'GET',
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken'),
          'X-Instance-Check': ''
        },
        params: {
          id: '@id'
        }
      }
    });
}]);
